export enum AUTH_VERDICT {
  PASS = 0,
  EMPTY = 1,
  WARNING = 2,
  ERROR = 3
}
export const AUTH_RESULT_PATTERN = /\b(dkim|spf|dmarc)=([a-z]+)\b/gi;
export const RECEIVED_HEADER_PATTERN = /^.*?(?=\s\bwith\b)/gi;

export const EMAIL_AUTH_ICON_MAP = {
  [AUTH_VERDICT.EMPTY]: "warning-circle",
  [AUTH_VERDICT.WARNING]: "warning-circle",
  [AUTH_VERDICT.PASS]: "checked",
  [AUTH_VERDICT.ERROR]: "error"
};

export const AUTH_RESULTS = {
  PASS: ["pass", "bestguesspass"],
  WARNING: ["neutral"],
  ERROR: [
    "none",
    "softfail",
    "fail",
    "temperror",
    "permerror",
    "quarantine",
    "reject"
  ]
};
